/**
 *
 * 刷新和关闭事件
 */

export default {
  mounted() {
    const now = new Date().getTime();
    // 从缓存中获取用户上次退出的时间戳
    const leaveTime = parseInt(localStorage.getItem("leaveTime"), 10);
    // 判断是否为刷新，两次间隔在5s内判定为刷新操作
    const refresh = now - leaveTime <= 5000;

    if (!refresh) {
      console.log("关闭");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("userName");
    } else {
      console.log("刷新");
    }
  }
};
